import React from "react";
import { useHistory } from "react-router-dom";

import { navigateHandler } from "utils/redirection";

import { LINK_TO_ROUTE } from "constants/common";

import styles from "./postLoginFooter.scss";

const year = new Date().getFullYear();

const { footer, copyright, bottomLinks, listing, inside_footer, container } = styles;
export default function PostLoginFooter({ source }) {
  const history = useHistory();

  return (
    <footer className={footer}>
      <div className={container}>
        <div className={inside_footer}>
          <div className={copyright}>© {year} Airtel. All Rights Reserved.</div>
          <div className={bottomLinks}>
            <ul className={listing}>
              <li>
                <a onClick={() => navigateHandler({ history, source, path: LINK_TO_ROUTE.HELP })}>Get Help</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
